import { render, staticRenderFns } from "./HonorType.vue?vue&type=template&id=20e5a51e&scoped=true"
import script from "./HonorType.vue?vue&type=script&lang=js"
export * from "./HonorType.vue?vue&type=script&lang=js"
import style0 from "./HonorType.vue?vue&type=style&index=0&id=20e5a51e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e5a51e",
  null
  
)

export default component.exports